/**
 * @file RepMobileFilterReset.js
 * @version 1.0.0
 * @author Cam Seymour
 * @project Excel Agri System
 * @created 2026-09-07
 * @modified 2026-09-07
 * @description Clear Filters, and nothing else, at the top of a search screen
 *              on a rep's phone.
 *
 *              A separate element rather than CSS over the existing header.
 *              That header holds a different set of buttons on each of the five
 *              screens — sync, create, export, admin-only items — in .btn-slideout
 *              wrappers whose width, hover and label behaviour are driven from
 *              App.css and from useSlideOutButton measuring them at runtime.
 *              Reaching into that with nth-child rules per screen meant five
 *              sets of positional selectors that break the moment a button is
 *              added, and one of them was silently matching nothing because of
 *              a typo in a class name.
 *
 *              So the header is hidden wholesale on the phone and this takes
 *              its place: one button, its own class, nothing inherited, nothing
 *              measured. It renders only on the rep phone shell, so the desktop
 *              header is untouched on every screen.
 */

import React from 'react';
import useRepMobile from '../hooks/useRepMobile';
import './RepMobileFilterReset.css';

function RepMobileFilterReset({ onReset, label = 'Clear Filters', disabled = false }) {
  const repMobile = useRepMobile();
  if (!repMobile) return null;

  return (
    <div className="rep-filter-reset">
      <button
        type="button"
        className="rep-filter-reset-btn"
        onClick={onReset}
        disabled={disabled}
      >
        <span className="material-symbols-rounded">filter_alt_off</span>
        <span>{label}</span>
      </button>
    </div>
  );
}

export default RepMobileFilterReset;
